
(function (sb) {
	sb.LayoutControls = (sb.LayoutControls || {});

    function showUpdateButton() {
         var isHidden = !GeneralSettings.hasGeneralSettings() && !Storyboard.LayoutDesigner.isAdmin
            || (Storyboard.LayoutDesigner.isMyStoryMode() && !Storyboard.HFilterLayout.hasHFilterNodes());

        $("#btnUpdateCharts").css("display", isHidden ? "none" : "");
        if (!Helpers.isPreview() && Storyboard.LayoutDesigner.isAdmin || !isHidden) {
            $("#pnlSettingsPanel").css("display", "block");
        }
        else if (!window.IsMyStories) {
            $("#pnlSettingsPanel").css("display", "none");
        }

        if( $('#hfilterTree').children().length > 0 ){
			$("#pnlSettingsPanel").removeClass('compactfilter');
			$('#btnUpdateCharts').css('margin-top', '22px');
        } else {
			$("#pnlSettingsPanel").addClass('compactfilter');
			$('#btnUpdateCharts').css('margin-top', '');
        }
    }

	function hideUpdateButton() {
		$("#btnUpdateCharts").hide();
	}

	function setChangeStoryboardButtonText(newText) {
		$('#btnChangeStoryboard').html(newText);
	}

	function showLoadingBar(message, cancelCallback) {
		if (!message || Storyboard.LayoutControls.loadingBarDisabled || $('#loadFeedBack').text() === message) return;
		$("#closeErrorPanel").hide();
		$("#updateChartsFailed").hide();
		$('#loadSpinner').show();
		$("#loadFeedBack div").css("display", "");
		var loadingbar = Storyboard.GuiEvents.centerObjectVertical($("#MessagePopup"));
		var messages = $('#loadFeedBack').data('messages') || [];
		messages.push(message);
		$(loadingbar).css("display", "block");
		applyInfoMsgStyle();
		$('#loadFeedBack').show();
		$("#loadFeedBack div").html(message);
		$('#loadFeedBack').data('messages', messages);
		if (cancelCallback) {
			$("#loadFeedBack div").prepend($("<input type='button' value='Cancel' class='DUIButtonGray' style='margin-right: 1em'/>"));
			$("#loadFeedBack div input[type='button']").bind("click", cancelCallback);
		}
		return message;
	}

	function hideLoadingBar(message) {
		var messages = $('#loadFeedBack').data('messages') || [];
		if (message && ~messages.indexOf(message)) {
			messages = messages.filter(function(m) { return m !== message; });
		} else {
			messages.pop();
		}
		if (Storyboard.LayoutControls.loadingBarDisabled) return;

		if (messages.length > 0 && $.active > 0) {
			$("#loadFeedBack div").html(messages[messages.length - 1]);
			$('#loadFeedBack').data('messages', messages);
		} else {
			$("#loadFeedBack > div").empty();
			$('#MessagePopup').removeClass('ErrorMessagePopup InfoMessagePopup').css('display', 'none');
			$('#loadFeedBack').data('messages', null);
		}
	}

	function showErrorMessages() {
		if (arguments.length > 0) {
			if (typeof arguments[0] == String) {
				showMessage(arguments[0]);
			}
		} else {
			if ($("#MessagePopup").filter(":visible").length == 0) {
				$('#loadFeedBack').hide();
				$("#MessagePopup").css("display", "block");
			} else {
				hideLoadingBar();
			}
		}
	}

	function showMessage(message) {
		$("#updateChartsFailed").hide();
		$("#loadFeedBack div").text(HTMLHelpers.htmlDecode(message));
		$('#loadSpinner').hide();
		$("#closeErrorPanel").show();
		var loadingbar = Storyboard.GuiEvents.centerObjectVertical($("#MessagePopup"));
		$(loadingbar).css("display", "block");
		$('#loadFeedBack').show();
	}

	function showError(errorMessage) {
		applyErrorMsgStyle();
		showMessage(errorMessage);
	}

	function applyErrorMsgStyle() {
		$("#MessagePopup").addClass('ErrorMessagePopup').removeClass('InfoMessagePopup');
	}

	function applyInfoMsgStyle() {
		$("#MessagePopup").addClass('InfoMessagePopup').removeClass('ErrorMessagePopup');
	}

	sb.LayoutControls.showUpdateButton = showUpdateButton;
	sb.LayoutControls.hideUpdateButton = hideUpdateButton;
	sb.LayoutControls.setChangeStoryboardButtonText = setChangeStoryboardButtonText;
	sb.LayoutControls.showErrorMessages = showErrorMessages;
	sb.LayoutControls.showMessage = showMessage;
	sb.LayoutControls.showError = showError;
	sb.LayoutControls.showLoadingBar = showLoadingBar;
	sb.LayoutControls.hideLoadingBar = hideLoadingBar;

})(window.Storyboard = (window.Storyboard || {}));
